import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=e79a6f2c&scoped=true&"
import script from "./tab.js?vue&type=script&lang=js&"
export * from "./tab.js?vue&type=script&lang=js&"
import style0 from "./tab.scss?vue&type=style&index=0&id=e79a6f2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e79a6f2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e79a6f2c')) {
      api.createRecord('e79a6f2c', component.options)
    } else {
      api.reload('e79a6f2c', component.options)
    }
    module.hot.accept("./Tab.vue?vue&type=template&id=e79a6f2c&scoped=true&", function () {
      api.rerender('e79a6f2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/AudienceManager/Components/Builder/OverviewTab/Tab.vue"
export default component.exports